export const LogoMark = ({ size = 32 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
  >
    <rect
      width="32"
      height="32"
      rx="6"
      fill="#0A0A0C"
      stroke="rgba(255,255,255,0.18)"
    />
    <path
      d="M6 20 L11 20 L14 9 L18 25 L21 15 L26 15"
      stroke="#FF5500"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
